import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getPageAnalyticsConfig, trackAnalyticsEvent } from '../utils/analytics';

const AnalyticsPageTracker: React.FC = () => {
  const location = useLocation();
  const lastTrackedKey = useRef<string | null>(null);

  useEffect(() => {
    const config = getPageAnalyticsConfig(location.pathname);
    if (!config) {
      return;
    }

    const trackingKey = `${location.pathname}${location.search}`;
    if (lastTrackedKey.current === trackingKey) {
      return;
    }
    lastTrackedKey.current = trackingKey;

    void trackAnalyticsEvent({
      ...config,
      path: trackingKey,
    });
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsPageTracker;
